import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-4" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_9 = { class: "col-md-6 d-flex justify-content-end align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_11 = {
  key: 0,
  class: "badge fs-20 bg-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_13 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 7,
  class: "dropdown"
}
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 4 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 5 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 8 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card mb-4" }, [
      _createElementVNode("div", { class: "card-body" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Reçu Colis")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "row g-3",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ScanRecuColis && _ctx.ScanRecuColis(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label" }, "Code Suivi :", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event)),
              placeholder: "Code Suivi",
              type: "text",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.codeColis]
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-3 d-flex align-items-end" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-success"
            }, [
              _createElementVNode("i", { class: "ph ph-scan" })
            ])
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("hr")
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "me-2" }, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users.per_page,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.users.per_page) = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (_ctx.getRecords()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "me-2"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.users.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchTerm) = $event)),
              class: "form-control me-2",
              placeholder: "Chercher",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter())),
              onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            (_ctx.auth.can('ADD_BR_C'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "btn btn-primary",
                  to: { name: 'AddReturnPage' }
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("span", { class: "text-nowrap" }, " Ajouter Bon de Retour (Client)", -1)
                  ])),
                  _: 1,
                  __: [12]
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          responsive: ""
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [13]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1),
                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                  (props.row.is_auto && props.row.is_auto == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Automatique "))
                    : _createCommentVNode("", true)
                ]))
              : (props.column.field === 'for_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(props.row.for_name) + ") ", 1))
                : (props.column.field === 'client')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      (props.row.magasin && props.row.magasin.client)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_14, _toDisplayString(props.row.magasin.client.store), 1))
                        : _createCommentVNode("", true),
                      (props.row.magasin.client.return_city)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[15] || (_cache[15] = _createTextVNode(" Retour : ", -1)),
                            _createElementVNode("b", null, _toDisplayString(props.row.magasin.client.return_city.name), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        (props.row.created_at != null)
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_16, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                      ]))
                    : (props.column.field === 'validate_time')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          (props.row.validate_time != null)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_18, _toDisplayString(_ctx.getDate(props.row.validate_time)), 1))
                            : _createCommentVNode("", true),
                          (props.row.duration_days && props.row.duration_days != '')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.numberPars(props.row.duration_days)) + " jours ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : (props.column.field === 'reçu')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            (props.row.reçu == 2)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_20, "1"))
                              : (_openBlock(), _createElementBlock("h5", _hoisted_21, "0"))
                          ]))
                        : (props.column.field === 'statut')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              (props.row.statut == 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                  }, " Nouveau ", 2))
                                : (props.row.statut == 1)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                    }, " En attenete d'expédition ", 2))
                                  : (props.row.statut == 2)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                      }, " Expédier vers client ", 2))
                                    : (props.row.statut == 3)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 3,
                                          class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                        }, " Reçu par client ", 2))
                                      : _createCommentVNode("", true)
                            ], 64))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _cache[24] || (_cache[24] = _createElementVNode("button", {
                                  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                  type: "button",
                                  "data-bs-toggle": "dropdown",
                                  "aria-expanded": "false"
                                }, [
                                  _createElementVNode("i", { class: "flaticon-dots" })
                                ], -1)),
                                _createElementVNode("ul", _hoisted_23, [
                                  (
                      _ctx.auth.can('BR_C') &&
                      props.row.statut == 0 &&
                      props.row.total_parcel != 0
                    )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.sentNoteAuto(props.row))
                                        }, _cache[16] || (_cache[16] = [
                                          _createElementVNode("i", { class: "flaticon-send me-1" }, null, -1),
                                          _createTextVNode(" Expédier ", -1)
                                        ]), 8, _hoisted_25)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.auth.can('BR_C'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.showNote(props.row))
                                        }, _cache[17] || (_cache[17] = [
                                          _createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]), 8, _hoisted_27)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.auth.can('BR_C'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (
                        _ctx.$router.push(
                          `/edit-return-client/${props.row.id}/${props.row.note_ref}`
                        )
                      )
                                        }, _cache[18] || (_cache[18] = [
                                          _createElementVNode("i", { class: "flaticon-edit me-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ]), 8, _hoisted_29)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.auth.can('BR_C') &&
                      props.row.statut == 0 &&
                      props.row.total_parcel == 0
                    )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.DeleteNote(props.row))
                                        }, _cache[19] || (_cache[19] = [
                                          _createElementVNode("i", { class: "flaticon-trash me-1" }, null, -1),
                                          _createTextVNode(" Supprimer ", -1)
                                        ]), 8, _hoisted_31)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.auth.can('BR_C') &&
                      props.row.statut == 1 &&
                      props.row.total_parcel != 0
                    )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.Expedier(props.row.id))
                                        }, _cache[20] || (_cache[20] = [
                                          _createElementVNode("i", { class: "flaticon-truck me-1" }, null, -1),
                                          _createTextVNode(" Expédier ", -1)
                                        ]), 8, _hoisted_33)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.auth.can('BR_C') &&
                      props.row.statut == 2 &&
                      props.row.total_parcel != 0
                    )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.RecievedBonDirect(props.row))
                                        }, _cache[21] || (_cache[21] = [
                                          _createElementVNode("i", { class: "flaticon-check me-1" }, null, -1),
                                          _createTextVNode(" Reçu Directe ", -1)
                                        ]), 8, _hoisted_35)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: ($event: any) => (_ctx.GetPDF(props.row))
                                    }, _cache[22] || (_cache[22] = [
                                      _createElementVNode("i", { class: "flaticon-download me-1" }, null, -1),
                                      _createTextVNode(" Télécharger ", -1)
                                    ]), 8, _hoisted_36)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, {
                                      class: "dropdown-item",
                                      to: {
                        name: 'timeline-return',
                        params: { id: props.row.id, refNote: props.row.note_ref },
                      },
                                      title: "Historique bon"
                                    }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createElementVNode("i", { class: "flaticon-clock me-1" }, null, -1),
                                        _createTextVNode(" Historique ", -1)
                                      ])),
                                      _: 2,
                                      __: [23]
                                    }, 1032, ["to"])
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ]))
}